// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YvOc","footer":"styles_footer__3FQwQ","passCodeTooltip":"styles_passCodeTooltip__3tL85"};